import * as React from "react";

interface SvgComponentProps extends React.SVGProps<SVGSVGElement> {
  color?: string; // Optional color prop
}

const SvgComponent: React.FC<SvgComponentProps> = ({
  color = "#CC4802",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M5.158 1.875v2.386c0 2.636 2.168 4.773 4.843 4.773s4.844-2.137 4.844-4.773V1.875h1.615v2.386c0 3.515-2.892 6.364-6.459 6.364-3.567 0-6.458-2.85-6.458-6.364V1.875h1.615Z"
      clipRule="evenodd"
    />
    <path
      fill={color}
      d="M3.543 18.125H16.46v-2.386c0-3.515-2.892-6.364-6.459-6.364-3.567 0-6.458 2.85-6.458 6.364v2.386Z"
    />
    <path
      fill={color}
      fillRule="evenodd"
      d="M2.5 1.667c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.667H3.333a.833.833 0 0 1-.833-.834Zm0 16.667c0-.46.373-.833.833-.833h13.334a.833.833 0 0 1 0 1.666H3.333a.833.833 0 0 1-.833-.833Z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgComponent;
